module.exports = __webpack_public_path__ + "static/WSC_Group_2016_Rental_Property_Tax_Checklist-87d2e0d916afeef06d8f3655f6dc2814.pdf";